import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { debounceTime } from 'rxjs';
import { BaseComponent, ConfigurationService, LoggerService, SecurityService } from 'saker-core';
import { NoteDTO } from 'src/app/Protocol/note.dto';
import { ProjectDTO } from 'src/app/Protocol/project.dto';
import { ProjectScenarioDTO } from 'src/app/Protocol/projectScenario.dto';
import { ProjectScenarioPageDTO } from 'src/app/Protocol/projectScenarioPage.dto';
import { ProjectScenarioService } from 'src/app/Service/project-scenario.service';
import { ProjectService } from 'src/app/Service/project.service';

@Component({
  selector: 'app-project-scenarios',
  templateUrl: './project-scenarios.component.html',
  styleUrls: ['./project-scenarios.component.css']
})
export class ProjectScenariosComponent extends BaseComponent implements OnInit {

  //-------------------------------
  // Model
  //-------------------------------

  project: ProjectDTO | null = null

  isShowDeleted = false;

  filterChanged = false

  redirectToFirst = false

  testDate: any = null

  showExportedDate = true

  showDeletedDate = true

  showLastUpdatedDate = true

  filter: any = {
    page: 1,
    sort: 'ExportedDate',
    ascending: false,
  }

  data: ProjectScenarioPageDTO | null = null

  //-------------------------------
  // Behaviour
  //-------------------------------

  pageChanged(newPage: number) {
    if (this.data)
      this.data.currentPage = newPage
    this.refreshData();
  }

  deletedFilter(item: { deletedDate: Date }) {

    if (this.isShowDeleted || !item.deletedDate)
      return true;
    else
      return false;
  };

  showDeleted() {
    this.isShowDeleted = !this.isShowDeleted;
    this.refreshData();
  };

  changeSort(sortType: string) {
    this.filter.sort = sortType;
    this.filter.ascending = !this.filter.ascending;
    this.refreshData();
  }

  showDashboard() {
    // $location.path("dsm/dashboard/");
    this.router.navigate(["home/"])
  }

  importScenario() {
    this.router.navigate(["projectScenarioImport/" + this.filter.mnemonic])
  }

  showRow(item: ProjectScenarioDTO) {
    // $location.path("dsm/projectScenario/" + item.projectScenarioId);
    this.router.navigate(["projectScenario/" + item.projectScenarioId])
  }

  countNotes(notes: NoteDTO[]) {
    return notes.filter((item) => {
      return item.deleted == false;
    }).length;
  }

  countDocuments(notes: NoteDTO[]) {
    //console.dir(notes);
    let sum = 0;
    let activeNotes = notes.filter((item) => {
      return item.deleted == false;
    });
    activeNotes.forEach((item) => {
      return sum += item.attachments.length;
    });
    return sum;
  }

  setExportedDate(date: Date | null) {
    if (date)
      this.filter.exportedDate = this.dateToShowDate(date)
    else
      this.filter.exportedDate = null
    this.applyFilter()
  }

  setDeletedDate(date: Date | null) {
    if (date)
      this.filter.deletedDate = this.dateToShowDate(date)
    else
      this.filter.deletedDate = null
    this.applyFilter()
  }

  setLastUpdatedDate(date: Date | null) {
    if (date)
      this.filter.lastUpdatedDate = this.dateToShowDate(date)
    else
      this.filter.lastUpdatedDate = null
    this.applyFilter()
  }

  //-------------------------------
  // Private
  //-------------------------------

  private storeProject(data: ProjectDTO) {
    this.project = data;
  }

  private refreshProject() {

    return this.projectService.getProject(this.filter.mnemonic)
      .subscribe((data) => { this.storeProject(data) })

  }

  private storeProjectScenario(data: ProjectScenarioPageDTO) {
    this.data = data;
  }

  private refreshData() {
    if (this.data)
      this.filter.page = this.data.currentPage;
    else
      this.filter.page = 1


    this.filter.showDeleted = this.isShowDeleted;
    console.log("this.filter")
    console.log(structuredClone(this.filter))
    return this.projectScenarioService.getProjectScenariosPaged(this.filter)
      .subscribe((data) => { this.storeProjectScenario(data) });
  }

  private applyFilter() {
    this.refreshData();
  }
  
  private dateToShowDate(date: Date) {

    let month = date.getMonth() + 1
    let day = date.getDate()

    let monthString = ""
    let dayString = ""

    if (month < 10) {
      monthString = "0" + month
    } else {
      monthString = month.toString()
    }

    if (day < 10) {
      dayString = "0" + day
    } else {
      dayString = day.toString()
    }

    return (date.getFullYear() + '-' + monthString + '-' + dayString)

  }

  //-------------------------------
  // Form
  //-------------------------------

  modalForm: any

  private setUp() {

    this.modalForm = new FormGroup({
      exportedScenarioName: new FormControl('', []),
      exportedScenarioLabel: new FormControl('', []),
      exportedScenarioId: new FormControl('', []),
      exportedScenarioInstance: new FormControl('', []),
      exportedByUser: new FormControl('', []),
      deletedByUser: new FormControl('', []),
      exportedDate: new FormControl('', []),
      deletedDate: new FormControl('', []),
      lastUpdatedDate: new FormControl('', []),
    });

    this.subscriptions.add(this.modalForm.valueChanges.pipe(debounceTime(400)).subscribe((val: any) => {
      this.applyFilter()
    }));

  }

  get exportedScenarioName() { return this.modalForm.get('exportedScenarioName'); }
  get exportedScenarioLabel() { return this.modalForm.get('exportedScenarioLabel'); }
  get exportedScenarioId() { return this.modalForm.get('exportedScenarioId'); }
  get exportedScenarioInstance() { return this.modalForm.get('exportedScenarioInstance'); }
  get exportedByUser() { return this.modalForm.get('exportedByUser'); }
  get deletedByUser() { return this.modalForm.get('deletedByUser'); }
  get exportedDate() { return this.modalForm.get('exportedDate'); }
  get deletedDate() { return this.modalForm.get('deletedDate'); }
  get lastUpdatedDate() { return this.modalForm.get('lastUpdatedDate'); }

  //-------------------------------
  // System
  //-------------------------------

  private activate() {

    this.activatedRoute.paramMap.subscribe((params: any) => {
      this.filter.mnemonic = params.params.mnemonic
    });

    this.refreshData();
    this.refreshProject();
  }

  constructor(
    security: SecurityService,
    configuration: ConfigurationService,
    logger: LoggerService,
    router: Router,
    modal: NgbModal,
    changeDetectorRef: ChangeDetectorRef,
    private projectService: ProjectService,
    private activatedRoute: ActivatedRoute,
    private projectScenarioService: ProjectScenarioService,
  ) {
    super(security, configuration, logger, router, modal, changeDetectorRef);
  }

  ngOnInit(): void {
    this.activate()
    this.setUp()
  }
}
